<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="1300">
      <v-card>
        <v-card-title>
          Estatisticas
        </v-card-title>
        <v-card-text class="pa-0">
          <div 
            :loading="loadingLast10"
            v-for="(c, index) in last10Concursos"
            :key="c.numero + '/' + index"
          >
            <v-container fluid class="pt-0 pb-0">
              <v-row class="pa-0">
                <v-col cols="1" xl="1" lg="1" md="1" sm="1" class="pt-0 pb-0">  
                  <span>Concurso: {{c.numero}}</span>
                </v-col>
                <v-col cols="11" xl="11" lg="11" md="11" sm="11" class="pa-0">  
                  <number-selector
                    class="pa-1"
                    v-model="c.concurso.numeros"
                    :qtde="25"
                    :readonly="true"
                    :size="30"
                  ></number-selector>
                </v-col>
              </v-row>
            </v-container>
            <v-divider></v-divider>
            
          </div>         
          <v-container fluid class="pt-0 pb-0">
            <v-row class="pa-0">
              <v-col cols="1" xl="1" lg="1" md="1" sm="1" class="pt-0 pb-0">  
                <span>Totais</span>
              </v-col>
              <v-col cols="11" xl="11" lg="11" md="11" sm="11" class="pt-0 pb-0 pr-0 pl-1">  
                <v-btn
                  v-for="n in somatorios"
                  :key="n"
                  class="number-button"
                  fab
                  dark
                  small
                  color="lotojr_numberDisable"
                  :width="30"
                  :height="30"
                >
                  {{ formatedNumber(n.qtde) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container> 
          <v-container fluid class="pt-0 pb-0">
            <v-row>
              <v-col cols="4" xl="4" lg="4" md="12" sm="12" class="pt-0 pb-0">
                <v-text-field
                  :loading="loadingLast10"
                  v-model="estatistica.impar"
                  label="Impar"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4" xl="4" lg="4" md="12" sm="12" class="pt-0 pb-0">
                <v-text-field
                  :loading="loadingLast10"
                  v-model="estatistica.par"
                  label="Par"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4" xl="4" lg="4" md="12" sm="12" class="pt-0 pb-0">
                <v-text-field
                  :loading="loadingLast10"
                  v-model="estatistica.primo"
                  label="Primo"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4" xl="4" lg="4" md="12" sm="12" class="pt-0 pb-0">
                <v-text-field
                  :loading="loadingLast10"
                  v-model="estatistica.frequencia"
                  label="Frequência"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4" xl="4" lg="4" md="12" sm="12" class="pt-0 pb-0">
                <v-text-field
                  :loading="loadingLast10"
                  v-model="estatistica.atraso"
                  label="Atraso"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4" xl="4" lg="4" md="12" sm="12" class="pt-0 pb-0">
                <v-text-field
                  :loading="loadingLast10"
                  v-model="estatistica.tendencia"
                  label="Tendência"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" 
            :loading="loadingLast10" 
            text 
            @click="onClose">Fechar</v-btn>
          <v-btn color="blue darken-1"
            :loading="loadingLast10"  
            text 
            @click="onSave">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import NumberSelector from "../../components/number-selector.vue";
export default {
  components: {
    "number-selector": NumberSelector,
  },
  props: {
    openEstatisticas: {
      type: Boolean,
    },
    editData: {
      type: Object,
    },
  },
  data() {
    return {
      dialog: false,
      estatistica: {},
      loadingLast10: false,
      last10Concursos: [],
      somatorios: []
    };
  },
  watch: {
    editData(v) {
      if(v){
        this.estatistica = {  ...v }
      }
    },
    openEstatisticas(v) {
      if (v) {
        this.dialog = true;
        this.loadingLast10 = true;
        this.$store
          .dispatch("findLast10Concursos")
          .then((value) => {
            value.sort(function (a, b) {
              return a.numero - b.numero
            })
            for (var i = 0; i < value.length; i++) {
              let n = [];
              for (var j = 0; j < value[i].concurso.numeros.length; j++) {
                n.push(value[i].concurso.numeros[j].numero);
                let index = this.somatorios.findIndex((p) => { return p.numero === value[i].concurso.numeros[j].numero })
                let obj = {};
                if (index < 0){
                  obj = {numero: value[i].concurso.numeros[j].numero, qtde : 1}
                  this.somatorios.push(obj);
                }else{
                  obj = this.somatorios[index];
                  obj.qtde = obj.qtde + 1;
                }                 
              }
              value[i].concurso.numeros = n;
            }
            if(this.somatorios.length < 25){
              for(i=1; i<=25; i++){
                let index = this.somatorios.findIndex((p) => { return p.numero === i })
                if(index < 0){
                  this.somatorios.push({numero: i, qtde : 0});
                }
              }
            }
            this.somatorios.sort(function (a, b) {
              return a.numero - b.numero
            })
            this.last10Concursos = value;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.loadingLast10 = false;
          });
      }
    },
  },
  methods: {
    onClose() {
      this.dialog = false;
      this.$emit("onCancelEstatistica");
    },
    formatedNumber(number) {
      return number < 10 ? "0" + number : number;
    },
    onSave() {
      this.loadingLast10 = true
       this.$store
          .dispatch("saveEstatistica",this.estatistica)
           .then((value) => {
          this.$store.dispatch('setNotification', {
            type: 'info',
            text: 'Registro salvo'
          })
          this.dialog = false;
        this.$emit("onSaveEstatistica");
        })
        .catch((err) => {
          this.$store.dispatch('setNotification', {
            type: 'warning',
            text: err
          })
        })
        .finally(() => {
          this.loadingLast10 = false
        })
      
    },
  },
};
</script>
<style scoped>
.number-button {
  margin: 5px;
}
</style>
